import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { ArrowLeft } from "lucide-react";
import BookingNew from "@/pages/reservations/ReservationsNew";

/** Form unico Reservations V2 aperto sopra l'Agenda (Staff/Admin). */
export default function ReservationFormOverlay({ entryPoint, prefill, backLabel, onClose, onSaved }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") { onClose(); } };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => { window.removeEventListener("keydown", onKey); document.body.style.overflow = ""; };
  }, [onClose]);

  return createPortal(
    <div className="fixed inset-0 z-[200] bg-sand-100 overflow-y-auto overscroll-contain" role="dialog"
         aria-modal="true" aria-label="Nuova prenotazione" data-testid="reservation-form-overlay">
      <header className="sticky top-0 z-20 bg-sand-50/90 backdrop-blur-md border-b border-sand-200 pt-[env(safe-area-inset-top)]">
        <div className="max-w-5xl mx-auto px-3 sm:px-4 h-14 flex items-center gap-3">
          <button type="button" onClick={onClose} data-testid="reservation-form-back"
                  className="h-10 px-3 rounded-full border border-sand-300 bg-white text-ink-700 text-sm inline-flex items-center gap-1.5 active:scale-95 transition-transform">
            <ArrowLeft className="w-4 h-4" /> {backLabel}
          </button>
          <div className="leading-tight min-w-0">
            <div className="eyebrow text-[10px]">Sarabi Reservations</div>
            <div className="text-sm text-ink-900 truncate">{prefill?.customer_phone ? "Duplica prenotazione" : "Nuova prenotazione"}</div>
          </div>
        </div>
      </header>
      <BookingNew prefill={prefill} entryPoint={entryPoint} onSaved={onSaved} />
    </div>,
    document.body,
  );
}
